var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list.length > 0
    ? _c("div", { staticClass: "opener opener--forbidden" }, [
        _c("h2", {
          staticClass: "opener__title",
          domProps: { textContent: _vm._s(_vm.trans.title) }
        }),
        _c(
          "ul",
          { ref: "container", staticClass: "opener__list" },
          [
            _vm._l(_vm.list, function(product, index) {
              return [
                _vm.opened.index === index
                  ? _c(
                      "li",
                      {
                        ref: "showup",
                        refInFor: true,
                        staticClass: "opener__showup"
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "opener__close",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.close($event, true)
                              }
                            }
                          },
                          [_vm._v("×")]
                        ),
                        _c("div", { staticClass: "opener__controls" }, [
                          _vm.hasNext
                            ? _c("a", {
                                staticClass: "opener__next icon-right",
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.next()
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm.hasPrev
                            ? _c("a", {
                                staticClass: "opener__prev icon-left",
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.prev()
                                  }
                                }
                              })
                            : _vm._e()
                        ]),
                        _c("div", { staticClass: "opener__card" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "product-card product-card--forbidden"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "product-card__content clearfix"
                                },
                                [
                                  _c("h1", {
                                    staticClass: "product-card__title",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.openedProduct.name
                                      )
                                    }
                                  }),
                                  _c("div", {
                                    staticClass: "product-card__content",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.openedProduct.text)
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _c(
                  "li",
                  {
                    ref: "elementsList",
                    refInFor: true,
                    staticClass: "opener__item",
                    class: {
                      "is-active": _vm.opened.element === product.id,
                      "opener__item--top": _vm.isLastLine(index)
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.open(product.id, index)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "product-preview",
                        class: {
                          "is-active": _vm.opened.element === product.id
                        }
                      },
                      [
                        _c("h3", {
                          staticClass: "product-preview__title",
                          domProps: { textContent: _vm._s(product.name) }
                        }),
                        _c("a", {
                          staticClass: "product-preview__link",
                          attrs: { href: product.alphabet_url }
                        })
                      ]
                    )
                  ]
                )
              ]
            })
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-338ebb09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-338ebb09","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/alphabet/forbidden.vue
// module id = 185
// module chunks = 4